<template>
  <div class="bidding">
    <!-- <base-empty-data v-if="list.length === 0" /> -->
    <template>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="bidding-list"
        :class="{ line: index == jShow }"
        @mouseenter="jMover(index)"
        @mouseleave="jShow = -1"
      >
        <div @click="$emit('goTo', item.id, item.typeName)">
          <div class="head">
            <div class="title">
              <span class="dataSourceTag" v-if="item.dataSources && item.dataSources !== 2">{{item.dataSourcesName}}</span>
              <span class="proName">{{ item.name }}</span>
            </div>
            <div class="titleInfo">
              <span style="color: #ff6600">【{{ item.type | tenderType }}】</span>
              <span class="moneySpan">
                预算金额：
                <span style="color: #ff6600">{{getMoney(item.money)}}</span>
              </span>
            </div>
            <img
              class="i-status"
              v-if="item.state === 2"
              src="@/assets/jjz.png"
            />
            <img
              class="i-status"
              v-else-if="item.state === 5"
              src="@/assets/tpz.png"
            />
            <img class="i-status" v-else src="@/assets/jjyjs.png" />
            <!-- <span class="i-status" :class="{blue: item.state == 2}">{{item.stateName}}</span> -->
          </div>
          <!-- 3.8 无脑循环 -->
          <div class="data-list">
            <template
              v-if="
                item.type == 6 ||
                item.type == 7 ||
                item.type == 8 ||
                item.type == 9 ||
                item.type == 10 ||
                item.type == 13 ||
                item.type == 20
              "
            >
              <div class="noshuju">
                <img src="@/assets/noshuju.png" alt="" />
                <div class="text-info">该类型无竞价清单</div>
              </div>
            </template>

            <template v-else>
              <BidItem :itemObj="item"></BidItem>
              <!-- <el-table :data="itemData">
                <el-table-column
                    v-for="(itt,index) in item.goodsHeader"
                    :key="index"
                    :label="itt.translate"
                    :prop="itt.name"
                    show-overflow-tooltip
                ></el-table-column>
              </el-table> -->
            </template>
          </div>
          <div class="footer">
            <p v-if="(item.state == 2 || item.state == 5) && item.applyEndTime">
              <span>截止时间：</span>{{  Number(item.applyEndTime) | formaHoures }}
            </p>
            <p v-else-if="item.state == 3 && item.calibrationTime">
              <span>定标时间：</span>{{ Number(item.calibrationTime) | formaHoures }}
            </p>
            <p v-else>
              <span>发布时间：</span>{{ Number(item.releaseTime) | formaHoures }}
            </p>
            <div class="com-box">
              <p><span> 采购单位： </span>{{ item.comName }}</p>
              <p
                v-if="
                  (item.type == 6 ||
                    item.type == 7 ||
                    item.type == 8 ||
                    item.type == 9 ||
                    item.type == 10 ||
                    item.type == 13 ||
                    item.type == 20) &&
                  item.isDisplay == 1
                "
              >
                <span v-if="item.rankType === 1">
                  <span> 最低报价： </span>{{ item.minMoney }}元
                </span>
                <span  v-if="item.rankType === 3">
                  <span> 最高报价： </span>{{ item.minMoney }}元
                </span>
              </p>
            </div>
            <p
              v-if="item.fullAddress"
              :title="item.fullAddress"
              class="aadressP"
            >
              <img src="@/assets/tender/areaImg.png" alt="" />
              <span>地址： </span>{{ item.fullAddress }}
            </p>
          </div>
        </div>
        <jPop
          v-if="index == jShow"
          :type="0"
          :item="item"
          @go="$emit('goTo', item.id, item.typeName)"
          @inByLetDialogClick="inByLetDialogClick"
        ></jPop>
      </div>
    </template>
    <!-- 函询 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      :dialogType="0"
      :typeData="typeData"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>

<script>
import apiIln from '@/api/zhaocai/apiLnquiryLetter.js'
export default {
  name: '',
  mixins: [],
  extends: {},
  components: {
    jPop: () => import('@/components/zhaocai/jPop'),
    BidItem: () => import('@/views/hotTender/components/BidItem'),
    InByLetDialog: () => import('@/components/zhaocai/InquiryLetterDialog')
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 控制函询dialog显示隐藏
      jMarkId: '',
      typeData: [],
      inByLetDialogShow: false,
      jShow: -1
    }
  },
  computed: {
    itemData: function () {
      let arr = []
      this.item.goodsList &&
        this.item.goodsList.map((list, index) => {
          let objData = {}
          list &&
            list.map((itt, i) => {
              objData[itt.name] = itt.value
            })
          arr.push(objData)
        })
      return arr
    }
  },

  methods: {
    getMoney (val) {
      if (val >= 10000) {
        return (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) + '万元'
      } else {
        return val + '元'
      }
    },

    // 函询
    async inByLetDialogClick (e, s, obj) {
      if (this.$store.state.loginType) {
        let res = {}
        if (s === 0) {
          res = await apiIln.getCheckAllowBidQuestion(e)
        } else {
          res = await apiIln.getCheckAllowTenderQuestion(e)
        }

        if (res.data.code === 0) {
          this.getTenderReceiverInquiry(obj.type)
          this.jMarkId = e
          this.$emit('jMover', this.jIndex)
          this.inByLetDialogShow = true
        } else {
          this.$message.error(res.data.msg)
        }
      } else {
        // 没有登录
        this.$store.commit('SET_LOGINDIALOG', true)
        return false
      }
    },
    async getTenderReceiverInquiry (type) {
      let pararms = {
        tenderingType: type
      }
      let { data } = await apiIln.getTenderReceiverInquiry(pararms)
      if (data.code === 0) {
        this.typeData = data.result
      }
    },
    // 函询dialog关闭方法
    closeinDialog (val) {
      this.inByLetDialogShow = val
    },
    async confirminDialog (obj, cab) {
      let data = { markId: this.jMarkId, ...obj }
      let res = await apiIln.getSaveForBid(data)
      if (res.data.code === 0) {
        this.$message.success(res.data.msg)
        this.inByLetDialogShow = false
      } else {
        this.$message.error(res.data.msg)
      }
      cab()
    },
    jMover (i) {
      this.jShow = i
    },
    tender (id) {
      if (this.$store.state.loginType) {
        // 登陆进来
        if (
          // this.$store.state.user.companyName &&
          !(
            this.$store.state.user.companyNo === '' ||
            this.$store.state.user.companyNo === '0'
          ) ||
          this.$store.state.user.realName !== ''
        ) {
          let routeUrl = this.$router.resolve({
            path: '/CompeteBiddingOffer',
            query: { no: id }
          })
          window.open(routeUrl.href, '_blank')
        } else {
          // 进入认证
          this.dialogCertificationVisible = true
          return false
        }
      } else {
        // 没有登录
        this.$store.commit('SET_LOGINDIALOG', true)
        return false
      }
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.bidding {
  width: 1178px;
  // min-height: 200px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  // border: 1px solid #e4e7ed;
  // border-top: none;
  .bidding-list {
    float: left;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    // border-radius: 6px;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 567px;
    height: 340px;
    &:nth-child(even) {
      margin-right: 0;
    }
    &:hover {
      border-bottom: none;
      transform: translateY(-19px);
      transition: all 0.2s ease-in-out;
      .footer {
        height: 72px;
      }
    }
    .footer {
      height: 110px;
      padding: 20px 10px;
      font-size: 14px;
      .com-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      p {
        margin-bottom: 10px;
        color: #333;
        img {
          width: 14px;
          height: 17px;
          vertical-align: text-bottom;
        }
        span {
          color: #666;
        }
      }
    }

    .company {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      // padding-left: 6px;
      // margin-left: 18px;
      // margin-right: 18px;
      height: 50px;
      line-height: 50px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .min-price {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 18px;
    }
    .head {
      height: 68px;
      width: 100%;
      background: #f5f7fa;
      overflow: hidden;
      box-sizing: border-box;
      position: relative;
      padding: 10px;
      border-bottom: 1px solid #e4e7ed;
      .title {
        box-sizing: border-box;
        width: 100%;
        height: 30px;
        margin-left: 8px;
        font-size: 16px;
        color: #333;
        font-weight: normal;
        display: flex;
        align-items: center;
        .proName{
          display: inline-block;
          width: calc(100% - 100px);
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
        .dataSourceTag {
          background: linear-gradient(90deg, #f17658 0%, #df361b 100%);
          color: #fff;
          font-size: 12px;
          width: 48px;
          height: 20px;
          padding: 3px;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .titleInfo {
        font-size: 14px;
        .moneySpan {
          color: #666666;
          margin-left: 10px;
        }
      }
      .i-status {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    // .list-item {
    //   overflow: hidden;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   padding: 0 10px;
    //   height: 60px;
    //   background: #f5f7fa;
    //   position: relative;
    //   .item-top {
    //     display: flex;
    //     height: 120%;
    //     flex-direction: column;
    //     justify-content: center;
    //     font-size: 14px;
    //     position: relative;
    //     .leftBtn {
    //       position: absolute;
    //       right: -120px;
    //       z-index: 999;
    //     }
    //     .item-type {
    //       width: 400px;
    //       text-overflow: ellipsis;
    //       overflow: hidden;
    //       white-space: nowrap;
    //       display: flex;
    //       font-size: 16px;
    //       span {
    //         color: #ff6600;
    //         white-space: nowrap;
    //         flex: 1;
    //       }
    //       h4 {
    //         margin: 0;
    //         padding: 0;
    //         font-weight: normal;
    //         padding-left: 10px;
    //         white-space: nowrap;
    //         overflow: hidden;
    //         text-overflow: ellipsis;
    //         width: 340px;
    //       }
    //     }
    //   }
    // }
    .data-list {
      margin: 0px 10px;
      height: 154px;
      overflow: hidden;
      border-bottom: 1px dashed #e4e7ed;

      .noshuju {
        text-align: center;
        img {
          padding-top: 25px;
          padding-bottom: 9px;
        }
        .text-info {
          font-size: 14px;
          color: #666666;
        }
      }
    }
    /deep/.data-list .el-table td {
      padding: 7px 0;
      border: 0;
    }
    /deep/.data-list .el-table th {
      padding: 7px 0;
      border: 0;
    }
    /deep/.el-table:before {
      height: 0;
    }
    /deep/.el-table .cell {
      color: #333333 !important;
    }
    /deep/.el-table .el-table__row .cell {
      color: #666666 !important;
    }
  }
  .line {
    border: 1px solid #b79255;
  }
}
// .i-status {
//   display: block;
//   position: absolute;
//   top: 9px;
//   right: -25px;
//   font-size: 12px;
//   color: #fff;
//   background-color: #999;
//   width: 90px;
//   height: 24px;
//   line-height: 24px;
//   text-align: center;
//   transform: rotate(45deg);
//   transform-origin: (0, 0);
// }
.blue {
  background-color: #409ee9;
}
</style>
